module.exports = __webpack_public_path__ + "img/BronzeCup.e7913230.svg";